import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { thirdRegister, getCode as _getCode } from '@/services/http';
import { writeCookie, readCookie } from '@/tools/tools';
import { validateTelPhone } from '@/tools/regexp';
import Footer from '@/common/footer.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 是否获取验证码
    _this.isCode = false;
    _this.count = 60;
    _this.timer = null;
    _this.form = {
      mobileNo: '',
      smsCode: ''
    };
    _this.rules = {
      mobileNo: [{
        validator: validateTelPhone,
        trigger: 'blur'
      }],
      smsCode: [{
        message: '请输入验证码',
        trigger: 'blur'
      }]
    };
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {}
    // 获取验证码
  }, {
    key: "getCode",
    value: function () {
      var _getCode2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getCode({
                phone: this.form.mobileNo,
                src: 3
              });
            case 2:
              res = _context.sent;
              if (res.data.code === 100) {
                this.$message.success('手机验证码已经成功发送，请注意查收！');
                this.isCode = true;
                this.countDown();
              } else {
                this.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCode() {
        return _getCode2.apply(this, arguments);
      }
      return getCode;
    }()
  }, {
    key: "wxLoginCallBack",
    value: function () {
      var _wxLoginCallBack = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, anchor, obj, path;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return thirdRegister({
                mobileNo: this.form.mobileNo,
                smsCode: this.form.smsCode,
                wxOpenId: this.$route.query.wxOpenId,
                unionId: this.$route.query.unionId,
                headImage: this.$route.query.headImage,
                qqUnionId: this.$route.query.qqUnionId,
                nickName: this.$route.query.nickName,
                equip: '',
                model: '',
                equipVersion: '',
                version: '',
                equipMeid: ''
              });
            case 2:
              res = _context2.sent;
              if (!(res.data.code === 100)) {
                _context2.next = 13;
                break;
              }
              writeCookie('accessToken', res.data.data);
              _context2.next = 7;
              return this.setUserInfoList();
            case 7:
              anchor = readCookie('anchor');
              if (anchor) {
                obj = {
                  accessToken: res.data.data,
                  userName: this.userinfor.userinfolist.nickName,
                  userId: this.userinfor.userinfolist.id,
                  userPhoto: this.userinfor.userinfolist.headImgUrl,
                  macCode: '',
                  phone: this.userinfor.userinfolist.phone
                };
                if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  this.webTransport.getUserLoginData(JSON.stringify(obj));
                } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
                  delete obj.accessToken;
                  obj.token = res.data.data;
                  window.QCefClient.invokeMethod('getUserLoginData', JSON.stringify(obj));
                } else {
                  window.JsIntrS.getUserLoginData(obj);
                }
              }
              path = this.$route.query.redirect;
              if (path) {
                this.$router.push(path);
              } else {
                this.$router.push('/');
              }
              _context2.next = 14;
              break;
            case 13:
              this.$message.error(res.data.message);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function wxLoginCallBack() {
        return _wxLoginCallBack.apply(this, arguments);
      }
      return wxLoginCallBack;
    }() // 比较版本
  }, {
    key: "compareVersion",
    value: function compareVersion(v1, v2) {
      v1 = v1.split('.');
      v2 = v2.split('.');
      var len = Math.max(v1.length, v2.length);
      // 调整两个版本号位数相同
      while (v1.length < len) {
        v1.push('0');
      }
      while (v2.length < len) {
        v2.push('0');
      }
      // 循环判断每位数的大小
      for (var i = 0; i < len; i++) {
        var num1 = parseInt(v1[i]);
        var num2 = parseInt(v2[i]);
        if (num1 > num2) {
          return 1;
        } else if (num1 < num2) {
          return -1;
        }
      }
      return 0;
    }
    // 倒计时
  }, {
    key: "countDown",
    value: function countDown() {
      var _this2 = this;
      this.timer = setInterval(function () {
        _this2.count -= 1;
        if (_this2.count <= 0) {
          clearInterval(Number(_this2.timer));
          _this2.isCode = false;
        }
      }, 1000);
    }
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
__decorate([State('user')], default_1.prototype, "userinfor", void 0);
default_1 = __decorate([Component({
  components: {
    Footer: Footer
  }
})], default_1);
export default default_1;